export default __webpack_public_path__ + "static/media/health.8d856b6e.jpg";